module.exports = __webpack_public_path__ + "static/q5-54ba66a5ae5b2e2ce849dc4cf03651e7.png";